<template>
  <div>
    <list
      row-key="SectionId"
      ref="list"
      unit="考勤事件设备设置"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="true"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="事件名称">
          <el-input type="text" v-model="params.name" placeholder="请输入事件名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="考勤对象人群" class="longLabel">
          <el-input type="text" v-model="params.dx" placeholder="请输入考勤对象" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="name" label="事件名称" show-overflow-tooltip />
        <el-table-column prop="dx" label="考勤对象人群" show-overflow-tooltip />
        <el-table-column prop="DeviceNo" label="考勤设备"/>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ed/section").default,
      params: {
        name: "",
        dx: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve,reject) => {
        resolve({ 
          Data: [
            { name: "事件名称1", dx: "教师", DeviceNo: "KQ001" }
          ]
        })
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>